module.exports = "/images/default.png?935530be5820b3e94252488182d71f3e";